import BREAKPOINT_LIST from 'ia-react-core/~/constants/BREAKPOINT_LIST';
import { Breakpoint } from 'ia-react-core/~/interfaces/Breakpoint';
import { useContext } from 'react';
import { ScreenClassContext } from 'react-grid-system';

export type UseBreakpointOptions = Breakpoint[];

export type UseBreakpointMinMaxOptions = [{
  min: Breakpoint;
  max?: Breakpoint;
}];

const useBreakpoint = (...options: UseBreakpointOptions | UseBreakpointMinMaxOptions) => {
  const upperBreakpoint = useContext(ScreenClassContext);
  const indexOfBreakpoint = BREAKPOINT_LIST.indexOf(upperBreakpoint);

  if (typeof options[0] !== 'object') {
    const breakpoints = options as UseBreakpointOptions;
    return breakpoints.includes(upperBreakpoint);
  }

  const indexOfMin = BREAKPOINT_LIST.indexOf(options[0].min);
  const indexOfMax = BREAKPOINT_LIST.indexOf(options[0].max || BREAKPOINT_LIST.at(-1));

  return (
    indexOfBreakpoint >= indexOfMin &&
    indexOfBreakpoint <= indexOfMax
  );
};

export default useBreakpoint;
